export default "__VITE_ASSET__CRFolIFm__"